import PropTypes from 'prop-types';
import useSharedGenrePageContext from '../../common/hooks/useSharedGenrePageContext';
import { GenreOptionComponentMobile } from '../../common/components/GenreOptionComponent';
import * as mobileStyles from '@/sass/pages/genre/Mobile/Mobile.module.scss';
import { classes } from '@/helpers/styling';
import Gradient, { GRADIENT_POSITION_LEFT, GRADIENT_POSITION_RIGHT } from '@/components/app/Gradient';
import LayoutWrapperHorizontal from '@/components/component-library/LayoutWrapperHorizontal';
import OptionSelectorHorizontalScrolling from '@/components/component-library/OptionSelectorHorizontalScrolling';
import Text, { FONT_SIZE_080 } from '@/components/component-library/Text';
import CaretIcon from '@/components/component-library/Icon/types/Caret';

const ENABLE_BACK_ARROW = false;
const ALL_OPTION_FIXED = false;
const SHOULD_HAVE_GRADIENT_LEFT = true;
const SELECTOR_GRADIENT_LEFT_STYLE = {
  height: 'calc(100% - 1px)',
  width: '5%'
};
const SELECTOR_GRADIENT_RIGHT_STYLE = {
  height: 'calc(100% - 1px)',
  width: '25%'
};

const selectorLeftScrollOffset = Number(mobileStyles['var-genre-scroller-left-padding'].replace('px', ''));

const GenreHeaderMobile = ({
  parentTitle,
  subgenreOptionsLoading
}) => {
  const { selectedGenre, selectorOptions } = useSharedGenrePageContext();

  return (
    <div className='mob__genre-header-fixed'>
      <LayoutWrapperHorizontal className='mob__genre-header'>
        { ENABLE_BACK_ARROW && <div className='mob__genre-back-arrow'><CaretIcon /></div> }
        <Text
          bold
          className='mob__genre-header-text'
          loading={ !parentTitle }
          size={ FONT_SIZE_080 } useHeaderFont
        >
          { parentTitle }
        </Text>
      </LayoutWrapperHorizontal>
      <div className='mob__genre-selector-wrapper'>
        { !ALL_OPTION_FIXED && SHOULD_HAVE_GRADIENT_LEFT && (
          <Gradient
            gradientBreadth='85%'
            position={ GRADIENT_POSITION_LEFT }
            style={ SELECTOR_GRADIENT_LEFT_STYLE }
          />
        ) }
        <OptionSelectorHorizontalScrolling
          className='mob__genre-selector'
          firstOptionFixed={ ALL_OPTION_FIXED }
          id='mobile-genre-selector'
          key={ parentTitle }
          leftScrollOffset={ selectorLeftScrollOffset }
          listClassName={ classes('mob__genre-selector-list', {
            '--is-loading': subgenreOptionsLoading,
            '--disable-padding': ALL_OPTION_FIXED
          }) }
          optionClassName='mob__genre-selector-option'
          OptionComponent={ GenreOptionComponentMobile }
          options={ selectorOptions }
          selectedId={ selectedGenre.id }
        />
        <Gradient
          directionReverse
          gradientBreadth='50%'
          position={ GRADIENT_POSITION_RIGHT }
          style={ SELECTOR_GRADIENT_RIGHT_STYLE }
        />
      </div>
      <div className='mob__genre-separator' />
    </div>
  );
};

GenreHeaderMobile.propTypes = {
  parentTitle: PropTypes.string,
  subgenreOptionsLoading: PropTypes.bool
};

GenreHeaderMobile.defaultProps = {
  parentTitle: '',
  subgenreOptionsLoading: false
};

export default GenreHeaderMobile;